// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getDealer} from '../../../product/shared/repositories';

export const readDealer = (account, accountIndex, closingAccountChangesArray) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            if (account) {

                const dealer = await getDealer(account);

                const overrideAccountUpdation = closingAccountChangesArray[accountIndex];

                overrideAccountUpdation.overrideAccount = dealer;

                dispatch({
                    overrideAccountUpdation,
                    type: actions.UPDATE_TCSM_CLOSING_ACCOUNT
                });

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };




// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/read-dealer.js